import { routes as invoiceRoutes } from './invoices'
import { routes as payInMethodRoutes } from './pay-in-methods'

export const routes = {
  ...invoiceRoutes,
  ...payInMethodRoutes,
} as const
